// ============================================================================
// vpn/VpnConnectionCard.tsx — карточка ОДНОГО подключения в списке пользователя:
// название, состояние и доступность. Технические параметры (протокол, сервер,
// порт, ключи) здесь НЕ показываются — только то, что нужно для выбора.
// ============================================================================

import { ShieldCheck, ShieldOff } from 'lucide-react';
import { cn } from '@/lib/utils';
import { vpnConnectionLabel, type VpnConnectionProfile } from './vpnTypes';

interface VpnConnectionCardProps {
  profile: VpnConnectionProfile;
  selected: boolean;
  connected: boolean;
  onSelect: () => void;
}

export function VpnConnectionCard({ profile, selected, connected, onSelect }: VpnConnectionCardProps) {
  const label = vpnConnectionLabel(profile);
  const state = connected
    ? { text: 'Подключено', cls: 'text-green-600 border-green-600/40 bg-green-600/5' }
    : profile.isActive
      ? { text: 'Доступно', cls: 'text-primary border-primary/30 bg-primary/5' }
      : { text: 'Недоступно', cls: 'text-muted-foreground border-border bg-muted/40' };

  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={selected}
      className={cn(
        'flex w-full items-center gap-3 rounded-lg border p-3 text-left transition-colors',
        selected ? 'border-primary/50 bg-accent/40 ring-1 ring-primary/30' : 'hover:bg-accent/10',
      )}
    >
      <span
        className={cn(
          'flex h-9 w-9 shrink-0 items-center justify-center rounded-full',
          profile.isActive ? 'bg-primary/10 text-primary' : 'bg-muted text-muted-foreground',
        )}
      >
        {profile.isActive ? <ShieldCheck className="h-4 w-4" /> : <ShieldOff className="h-4 w-4" />}
      </span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm font-medium">{label}</span>
      </span>
      <span className={cn('shrink-0 rounded-full border px-2 py-0.5 text-[10px]', state.cls)}>
        {state.text}
      </span>
    </button>
  );
}
